// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// NOTE - this function is passed down to <DataTable /> so we can determine if a row should update
// called on each row's shouldComponentUpdate, it allows us to more quickly render updates
// to individual paths (highlighting for example.) when a large number of paths is displaying.

const shouldRowUpdate = (oldProps, newProps) => {
  const {
    customProps = {},
    rowData,
  } = oldProps

  // TODO NEXT
  return true

  const { highlightedRows } = customProps

  // there's no reason to rerender this component if
  // it can't be highlighted.
  if (!highlightedRows) {
    return false
  }

  const uniqueValue = rowData[rowData.uniqueId]

  // if highlight was toggled, then rerender
  const highlighWasToggled = (
    highlightedRows.indexOf(uniqueValue) !== newProps.customProps.highlightedRows.indexOf(uniqueValue)
  )

  // if the index was changed for this path,
  // another search was run and we need to
  // but the original path was also in the new search results
  // so we gotta update the index in the next render cycle
  const indexWasUpdated = rowData.pathIndex !== newProps.rowData.pathIndex

  return highlighWasToggled || indexWasUpdated
}

export default shouldRowUpdate
